import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';
import { UnmatchedOrderItem } from '../domains/entities/UnmatchedOrderItem';
import { GetUnmatchedOrdersAdapter } from '../adapters/getUnmatchedOrdersAdapter';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IPagingOptions } from '@/coreDomainsModule/paging';

/**
 * 未照合・差異一覧情報を取得するユースケース
 */
export class GetUnmatchedOrdersUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 未照合・差異一覧情報を取得する
   * @param limit - 取得上限
   * @param offset - オフセット
   * @param filterItems - フィルターモーダルで選択されたフィルター項目
   * @returns 未照合・差異一覧情報
   */
  public async execute(
    limit: number,
    offset: number,
    filterItems?: FilterContentItem[]
  ): Promise<INetworkResult<[IPagingOptions, UnmatchedOrderItem[]], IError>> {
    const filterItem = filterItems !== undefined && filterItems.length > 0 ? FilterService.convertFilterObject(filterItems) : undefined;
    const networkResult = await this.repository.get(limit, offset, filterItem);
    switch (networkResult.status.type) {
      case 'success': {
        const pagingOptions = networkResult.status.data.result.pagingOptions;
        const items = GetUnmatchedOrdersAdapter.adapt(networkResult.status.data.result.unmatchedOrders);
        return { status: { type: 'success', data: [pagingOptions, items] } };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
